export const Options = {
  chart: {
    id: 'Engagement',
    height: 350,
    type: 'line',
    stacked: false,
  },
  stroke: {
    width: [0, 0, 2],
    curve: 'smooth',
    // curve: 'straight',
    dashArray: [0, 0, 5],
  },
  plotOptions: {
    bar: {
      columnWidth: '50%',
      borderRadius: 5,
      borderRadiusApplication: 'end',
    },
  },
  colors: ['#0078FF', '#FF9E00', '#FF4D00'],
  fill: {
      // type: 'gradient',
      type: ['gradient', 'solid', 'solid'],
      opacity: [1, 0.3, 1],
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.6,
        gradientToColors: ['#00D7FF'],
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 40, 100],
        colorStops: [],
    },
  },
  // fill: {
  //   colors: ['#00d7ff', '#ff9e00', '#F1914F'],
  //   opacity: [0.85, 0.25, 1],
  //   gradient: {
  //     inverseColors: false,
  //     shade: 'light',
  //     type: 'vertical',
  //     opacityFrom: 0.85,
  //     opacityTo: 0.25,
  //     stops: [0, 80, 90, 100],
  //   },
  // },
  // labels: ['27 Oct', '28 Oct', '29 Oct', '30 Oct', '31 Oct', '01 Nov', '02 Nov', '03 Nov', '04 Nov', '05 Nov', '06 Nov', '07 Nov', '08 Nov', '09 Nov', '10 Nov', '11 Nov', '12 Nov', '13 Nov', '14 Nov', '15 Nov', '16 Nov', '17 Nov', '18 Nov', '19 Nov', '20 Nov', '21 Nov', '22 Nov', '23 Nov', '24 Nov', '25 Nov',
  // ],
  markers: {
    size: 0,
  },
  // xaxis: {
  //   type: 'datetime',
  // },
  yaxis: [
    {
      axisTicks: {
        show: true,
      },
      seriesName: 'Click Throughs',
      axisBorder: {
        show: true,
        color: '#00d7ff',
      },
      labels: {
        style: {
          colors: '#00d7ff',
        },
      },
      title: {
        text: 'Click Throughs',
        style: {
          color: '#00d7ff',
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    {
      seriesName: 'Reminder Impressions',
      opposite: true,
      showAlways: true,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#ff9e00',
      },
      labels: {
        style: {
          colors: '#ff9e00',
        },
      },
      title: {
        text: 'Impressions',
        style: {
          color: '#ff9e00',
        },
      },
    },
    {
      seriesName: 'Event Impression',
      opposite: true,
      show: false,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#ff9e00',
      },
      labels: {
        style: {
          colors: '#ff9e00',
        },
      },
      title: {
        text: 'Reminder Impressions',
        style: {
          color: '#ff9e00',
        },
      },
    },
  ],
  tooltip: {
    shared: true,
    intersect: false,
    y: {
      formatter: function (y) {
        if (typeof y !== 'undefined') {
          return y.toFixed(0) + '';
        }
        return y;
      },
    },
  },
};

// export const Options = {
//     chart: {
//       height: 350,
//       type: 'line',
//       stacked: true,
//     },
//     stroke: {
//       width: [0, 2, 5],
//       curve: 'smooth',
//     },
//     plotOptions: {
//       bar: {
//         columnWidth: '50%',
//       },
//     },
//     fill: {
//       opacity: [0.85, 0.25, 1],
//       gradient: {
//         inverseColors: false,
//         shade: 'light',
//         type: 'vertical',
//         opacityFrom: 0.85,
//         opacityTo: 0.55,
//         stops: [0, 100, 100, 100],
//       },
//     },
//     labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003',
//       '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003',
//     ],
//     markers: {
//       size: 0,
//     },
//     xaxis: {
//       type: 'datetime',
//     },
//     yaxis: {
//       title: {
//         text: 'Points',
//       },
//       min: 0,
//     },
//     tooltip: {
//       shared: true,
//       intersect: false,
//       y: {
//         formatter: function (y) {
//           if (typeof y !== 'undefined') {
//             return y.toFixed(0) + ' points';
//           }
//           return y;
//         },
//       },
//     },
//   };
